module.exports = __webpack_public_path__ + "static/media/discord.2fe43beb.png";